










import { SettingsVueGB } from "@/extensions/settings/SettingsVueGB";
import { Component, Prop } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import LoginWithoutPassword from "@/components/auth/LoginWithoutPassword.vue";
import { clientTime } from "fs-pb-vue2/utilities";
import { Http } from "fs-pb-vue2/services/api/http";
import { DeclarationPropertiesTypes, OperationRequestData } from "fs-pb-vue2/data";
import { appConfig } from "fs-pb-vue2/config";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";
import { AppStore } from "fs-pb-vue2/store/modules/app";
import { getModule } from "vuex-module-decorators";

@Component({
  components: { BackLink, LoginWithoutPassword }
})
export default class ShortCodeSetModal extends SettingsVueGB {

  @Prop() backTitle!: string;

  get backTitleValue(): string {
    return this.backTitle || "Смена короткого кода";
  }

  @Prop() pinPadBackBtnText!: string;

  get pinPadBackBtnTextValue(): string {
    return this.pinPadBackBtnText || "Назад";
  }

  execLoading: boolean = false;
  newPin!: string;
  createCodeStep: boolean = true;
  confirmCodeStep: boolean = false;

  /**Стор настроек */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }

  createPinAction(pin: string) {
    this.newPin = pin;
    this.createCodeStep = false;
    this.confirmCodeStep = true;
  }

  back() {
    this.$emit('backAddAction');
    this.destroyForm();
  }

  async confirmPinAction(pin: string) {
    if (this.newPin != pin) {
      this.alertService.error("Введенные короткие коды не совпадают");
      return;
    }
    await this.setPin(pin);
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }

  async setPin(pinCode: string) {
    this.appStore.setLoading(true);
    try {
      if (!window.localStorage.getItem('deviceId')) {
        window.localStorage.setItem('deviceId', this.uuidv4())
        await this.setDeviceInfo();
      }
      const data =
      {
        devId: window.localStorage.getItem('deviceId'),
        pin: pinCode,
        typeSource: "1",
        clientTime: clientTime()
      };
      await Http.post('webclient/CreatePin', data);
      window.localStorage.setItem('loginWithoutPasswordOn', '1');
      this.appStore.setLoading(false);
      this.alertService.success("Короткий код успешно установлен.");
      this.back();
    } catch (ex: any) {
      this.appStore.setLoading(false);
      this.alertService.error(ex.message);
    }
  }

  toCodeCreation() {
    this.newPin = "";
    this.createCodeStep = true;
    this.confirmCodeStep = false;
  }

  async setDeviceInfo(): Promise<void> {
    if (!this.configStore.apiData.OperationCodeOfSetClientDeviceInfo)
      throw new Error("tech error");

    const ord: OperationRequestData = new OperationRequestData();
    ord.respondentCode = this.configStore.apiData.OperationCodeOfSetClientDeviceInfo;
    ord.setProperty("DeviceId", window.localStorage.getItem('deviceId'), DeclarationPropertiesTypes.String);
    ord.setProperty("AppVersion", appConfig.version, DeclarationPropertiesTypes.String);
    ord.setProperty("OS", navigator.platform, DeclarationPropertiesTypes.String);
    ord.setProperty("Model", navigator.userAgent, DeclarationPropertiesTypes.String);
    ord.setProperty("PushToken", "", DeclarationPropertiesTypes.String);
    ord.setProperty("PushEnabled", "0", DeclarationPropertiesTypes.String);


    await OperationsApi.executeAnonymousOperationSendAsync(ord);

  }
}

